import React from "react";
import { Box, Button, Stack } from "@mui/material";
import Toolbar from "../../common/Toolbar";
import Workspace from "../Workspace";
import { JOB_CHANGE_LEADS_COLUMNS } from "./common/monitorColumns";
import PeopleAgentResults from "./PeopleAgentResults";
import { useDialog } from "../../context/DialogContext";
import CreateAgent from "../../modal/CreateAgent";
import { peopleAgentType } from "./common/AgentTypes";

export default function JobChangeLeads(props) {
	const dialog = useDialog();
  const CREATE_TITLE = "Create people agent";

	return (
		<Box sx={{ height: "100vh" }}>
			<Toolbar>
				<Stack direction="row" alignItems="center">
					People signals
				</Stack>
				<Button
					onClick={() => {
						dialog.openModal(
							CREATE_TITLE,
							CreateAgent,
							{
								agentType: peopleAgentType,
							},
							"lg"
						);
					}}
					variant="contained"
					disableRipple
					disableElevation
					sx={{ alignSelf: "center" }}
				>
					{CREATE_TITLE}
				</Button>
			</Toolbar>
			<Workspace>
				<PeopleAgentResults columns={JOB_CHANGE_LEADS_COLUMNS} />
			</Workspace>
		</Box>
	);
}
